import React from 'react'
import { connect } from 'react-redux'
import { CrudEventEnum, EntityTypeEnum, OrganisationMetaDetail, WorkflowActions } from 'api'
import { ActionItem, SplitButtonDropdown } from 'view/components/menus'
import { ActionsButtonProps } from 'view/components/datagrid'
import { ModalConsumerProps, withModal } from 'view/shared/modal'
import { NotificationActions, NotificationType, ShowDialogArgs } from 'store/notification'
import { Locale, Translation } from 'locale'
import { isNil } from 'lodash-es'

export interface TradeSplitActionsButtonProps extends ModalConsumerProps, ActionsButtonProps<OrganisationMetaDetail> {
  context: {
    workflowId: string
  }
  onShowDialog: (dialogArgs: ShowDialogArgs) => unknown
  onDelete: typeof WorkflowActions.createEntitiesCreateAndSubmitReferenceData
  onDeleteFromWorkflow: typeof WorkflowActions.createEntityDeleteReferenceData
}

const mapDispatchToProps = {
  onShowDialog: NotificationActions.showDialog,
  onDelete: WorkflowActions.createEntitiesCreateAndSubmitReferenceData,
  onDeleteFromWorkflow: WorkflowActions.createEntityDeleteReferenceData
}

export const TradeSplitActionsButtonComponent: React.FunctionComponent<TradeSplitActionsButtonProps> = props => {
  const { items, context, showDialog, onDelete, onDeleteFromWorkflow } = props

  const deleteItems = items.filter(item => item.availableEvents.includes(CrudEventEnum.DELETE))

  const handleDelete = async () => {
    const dialogArgs = {
      type: NotificationType.Confirm,
      title: deleteItems.length === 1 ? Translation.TC_DELETE_SPLIT_TRADE_ENTRY : Translation.TC_DELETE_SPLIT_TRADE_ENTRIES,
      message:
        deleteItems.length === 1
          ? Translation.SC_DELETE_SPLIT_TRADE_ENTRY_CONFIRMATION
          : Translation.SC_DELETE_SPLIT_TRADE_ENTRIES_CONFIRMATION,
      buttons: [Translation.TC_BUTTON_YES, Translation.TC_BUTTON_NO],
      defaultButton: Translation.TC_BUTTON_YES,
      cancelButton: Translation.TC_BUTTON_NO
    }
    const dialogResult = await showDialog(dialogArgs)

    if (dialogResult === Translation.TC_BUTTON_YES) {
      const deleteEntities = deleteItems.map(item => ({
        entityId: item.organisationMeta.id,
        entityType: EntityTypeEnum.ORGANISATION_META
      }))
      if (isNil(context?.workflowId)) {
        onDelete([], deleteEntities)
      } else {
        onDeleteFromWorkflow(deleteEntities, context?.workflowId)
      }
    }
  }

  const actions: ActionItem[] = [
    {
      label: Locale.translate(Translation.TC_ACTION_DELETE),
      onClick: handleDelete,
      enabled: deleteItems.length > 0
    }
  ]

  return <SplitButtonDropdown actions={actions} maxButtons={1} />
}

export const TradeSplitActionsButton = withModal(connect(null, mapDispatchToProps)(TradeSplitActionsButtonComponent))
